export default "__VITE_ASSET__B08wHx3y__"